import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { ComponentProps, Fragment, ReactNode } from 'react';

import { CropModalPanel } from '~modules/media-library/view/CropModal/CropModalPanel';

type CropModalProps = Resolve<
  Pick<
    ComponentProps<typeof CropModalPanel>,
    | 'asset'
    | 'cropFormats'
    | 'cropFormat'
    | 'selectedCropFormat'
    | 'onSelectCropFormat'
    | 'onCustomWidthChanged'
    | 'onCustomHeightChanged'
    | 'onDownload'
    | 'isProcessing'
  > & {
    isOpen: boolean;
    onClose: () => void;
    children?: ReactNode;
  }
>;

export function CropModal({ isOpen, onClose, children, ...PanelProps }: CropModalProps) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} as="div" className="relative z-40">
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-80"
          leave="ease-in duration-200"
          leaveFrom="opacity-80"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black opacity-80" />
        </TransitionChild>
        <div className="fixed inset-0 p-8 flex justify-center items-center overflow-hidden">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95 translate-y-4"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95 translate-y-4"
          >
            <DialogPanel as={CropModalPanel} {...PanelProps} onClose={onClose} className="transition-all transform">
              {children}
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
